import { StaticElevationSvgJsx } from "../../components/ApartmentFinder/Components/SvgJSX"
import {
  PlanFavouriteContainer,
  TitleBar,
  FloorPlan,
  Dimensions,
  BedTitle,
  FloorTitle,
  PlotTitle,
  InfoHolder,
  ElevationHolder
} from "./PlanFavouriteCard.styles"
import { useApartmentByFloorPlanCode } from "../ApartmentFinder/Utils/hooks"

// import styles from "./PlanFavouriteCard.module.css"

export default function PlanFavouriteCard({ data, onClick }) {
  const bedsTypes = {
    1: "1",
    2: "2",
    3: "3",
    4: "4"
  }

  const floorPlanCode = useApartmentByFloorPlanCode()[148]
  let isBlockD =
    data?.blockID === "D1" || data?.blockID === "D2" || data?.blockID === "D4"
  let isBlockC5 = data?.blockID === "C5"

  console.log("first", data)

  return (
    <PlanFavouriteContainer>
      <TitleBar>
        <PlotTitle>Plot {data.id}</PlotTitle>
        <FloorTitle>Floor {data.floor_no}</FloorTitle>
        <BedTitle>
          {bedsTypes[data.beds]} Bed{data.beds === "1" ? "" : "s"},{" "}
          {bedsTypes[data.bathrooms]} Bath{data.bathrooms === "1" ? "" : "s"}
        </BedTitle>
      </TitleBar>
      <FloorPlan>
        {isBlockD || isBlockC5 ? (
          <img
            style={{ width: "90%" }}
            src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/images/floorplans/new/${floorPlanCode}.png`}
            alt={""}
          ></img>
        ) : (
          <img
            style={{ width: "90%" }}
            src={`${
              process.env.PUBLIC_URL
            }/assets/apartmentfinder/images/floorplans/${data.flatType.toLowerCase()}${
              data.floor_no !== "1" &&
              (data.flatType.toLowerCase() === "e11" ||
                data.flatType.toLowerCase() === "e10")
                ? "-t"
                : ""
            }.jpg`}
            alt={""}
          ></img>
        )}
      </FloorPlan>
      <InfoHolder>
        <Dimensions>
          <img
            style={{ width: "100%" }}
            src={`${
              process.env.PUBLIC_URL
            }/assets/apartmentfinder/images/floorplans/${data.flatType.toUpperCase()}.svg`}
            alt=""
          ></img>
        </Dimensions>
        <ElevationHolder>
          <StaticElevationSvgJsx
            // activeBlock={"D4"}
            activeBlock={data.blockID}
            forCard={true}
            isCard={true}
            floor={String(data.floor_no)}
          />
        </ElevationHolder>
      </InfoHolder>
    </PlanFavouriteContainer>
  )
}
